import { Observable, throwError } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WordpressPaging } from '@app/enums/_index';
import { StaticPageInterface } from '@app/interfaces/static-page.interface';
import { getCacheBustedParams } from '@app/utilities/_index';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class LearningPathsService extends ErrorHandlerService {
  private learningPathContentURL = `${environment.cms.url}/wp-json/wp/v2/learningpath`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Returns all the information related to learning path
   * @returns Learning Path content Observable
   */
  getLearningPathContent(): Observable<StaticPageInterface[]> {
    const learningPathContentParams = getCacheBustedParams()
      .append(WordpressPaging.ORDER_BY_KEY, WordpressPaging.ORDER_BY_VALUE)
      .append(WordpressPaging.ORDER_KEY, WordpressPaging.ORDER_VALUE);

    return this.http
      .get(`${this.learningPathContentURL}`, { params: learningPathContentParams })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<StaticPageInterface[]>('getLearningPathContent', []))
      );
  }
}
